import React from 'react';
import {
  Table, Icon,
} from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { visibilityIcon } from '@/constants/images';

const VisibilityCell = ({ visibility }) => (
  <Table.Cell singleLine>
    <span>
      <Icon className="primary" name={visibilityIcon[visibility]} />
      <FormattedMessage id={`visibility.simple.${visibility}`} />
    </span>
  </Table.Cell>
);

export default VisibilityCell;
